import { inject } from "mobx-react";
import { PlayIcon } from "../../../../../core/components/icons/PlayIcon.component";
import type { Store } from "@inferno/renderer-shared-core";
import { Remote } from "../../../../../core/components/remote/Remote.component";
import { isPWSSessionBackend, PwsViewMediaEpisodeResponse } from "@inferno/renderer-shared-core";
import { ButtonKind, FauxButton, Heading } from "../../../../../core/ui";
import { COAST_SHOW_TYPE } from "../../../lib/coastContent";
import { coastMediaService } from "../../../../../core/services/Pws";

interface CoastShowAudioboxABVProps {
  episodesInfo: Record<string, PwsViewMediaEpisodeResponse>;
  episodes: string[];
  showUrl: "art-bell-vault" | "somewhere-in-time";
}

interface CoastShowAudioboxABVLoaderProps {
  episodes: string[];
  store?: Store;
  showType: string;
}

const CoastShowAudioboxABV = ({ episodes, episodesInfo, showUrl }: CoastShowAudioboxABVProps) => (
  <section className="audiobox-section coast-abv">
    {episodes?.length ? <Heading level={3}>Show Audio</Heading> : null}
    <div className="audiobox-section-value">
      {Object.values(episodes).map((slug, i) =>
        showUrl && slug ? (
          <div key={slug} className="link-with-icon">
            <FauxButton
              to={`/videos/${showUrl}/${slug}/`}
              kind={ButtonKind.CUSTOMIZED}
              className="media-link"
              download="download"
            >
              {episodesInfo[slug]?.video?.title || `Episode ${i + 1}`}
            </FauxButton>
            <FauxButton
              kind={ButtonKind.CUSTOMIZED}
              className="media-link"
              download="download"
              to={`/videos/${showUrl}/${slug}/`}
            >
              <PlayIcon />
            </FauxButton>
          </div>
        ) : null,
      )}
    </div>
  </section>
);

export const CoastShowAudioboxABVLoader = inject("store")(
  ({ store, episodes, showType }: CoastShowAudioboxABVLoaderProps) => {
    const session = store?.session.currentSession;

    if (!store || !episodes.length || !isPWSSessionBackend(session)) {
      return null;
    }
    const showUrl = showType === COAST_SHOW_TYPE.ART_BELL_VAULT ? "art-bell-vault" : "somewhere-in-time";
    return (
      <Remote
        loader={() => coastMediaService.getMediaEpisodeBySlugBulk(episodes, session.state.accessToken)}
        cacheKey={`coast-show-audiobox-abv-${episodes.join(",")}-${session.state.hasActiveSubscription}`}
        showLoading={true}
      >
        {({ data }) =>
          data ? <CoastShowAudioboxABV episodes={episodes} episodesInfo={data} showUrl={showUrl} /> : null
        }
      </Remote>
    );
  },
);
